import { BlockProductFeedEntityHydrated, EntityId } from "@jackfruit/common"
import React from "react"
import { useLocation } from "react-use"
import Wrapper from "~/components/Wrapper"
import { useCurrentAvailableProductsForPageAndDefaultFultillment } from "~/hooks/useCurrentAvailableProductsForPageAndDefaultFultillment"
import { useForceCanonicalForPage } from "~/hooks/useForceCanonicalForPage"
import { usePageSession } from "~/hooks/usePageSession"
import { useProduct } from "~/hooks/useProduct"
import { useProductIdFromUrl } from "./hooks/useProductIdFromUrl"
import ProductFeedContent from "./ProductFeedContent"
import ProductFeedNotFound from "./ProductFeedNotFound"
import ProductFeedSkeleton from "./ProductFeedSkeleton"

interface Props {
  config: BlockProductFeedEntityHydrated
  pageId: EntityId
}

const ProductFeedBlock: React.FC<Props> = ({ pageId, config }) => {
  const { href } = useLocation()
  useForceCanonicalForPage(pageId, href ?? "")

  const productId = useProductIdFromUrl()
  const {
    pageSession: { isReady },
  } = usePageSession()

  const { products: availableProducts } =
    useCurrentAvailableProductsForPageAndDefaultFultillment()

  const { product } = useProduct(productId)

  const productIdToUse = Boolean(productId)
    ? productId
    : availableProducts[0]?.id

  const cannotFindProduct = !Boolean(product) && isReady

  let component = <ProductFeedSkeleton />
  if (cannotFindProduct && productId) {
    component = <ProductFeedNotFound />
  } else if (isReady) {
    component = (
      <ProductFeedContent
        pageId={pageId}
        productId={productIdToUse}
        config={config}
      />
    )
  }

  return (
    <Wrapper
      maxWidth="1000px"
      minHeight={{ base: "780px", md: "560px" }}
      borderBottomWidth={1}
    >
      {component}
    </Wrapper>
  )
}

export default ProductFeedBlock
